import { injectable, inject } from 'inversify'
import type { FetchOptions } from 'ofetch'

import { HTTPClient } from './HTTPClient'
import type { ApiClient, ClientRegistry, ClientRegistration } from './types'
import { LinkCreator } from '../LinkCreator'

@injectable()
export class ApiClientStrategy implements ClientRegistry {
  private registeredClients: ClientRegistration[] = []

  constructor(
    @inject(LinkCreator) readonly linkCreator: LinkCreator,
    @inject(HTTPClient) readonly httpClient: ApiClient,
  ) {
    this.registerClient({
      client: this.httpClient,
      selector: () => true,
      priority: 0,
    })
  }

  /**
   * Регистрирует новый клиент в стратегии
   */
  registerClient(registration: ClientRegistration): void {
    this.unregisterClient(registration.client)
    this.registeredClients.push(registration)
    this.registeredClients.sort((a, b) => b.priority - a.priority)
  }

  unregisterClient(client: ApiClient): void {
    this.registeredClients = this.registeredClients.filter(
      registration => registration.client !== client
    )
  }

  getClient(options: FetchOptions<'json'>, body?: unknown): ApiClient {
    for (const registration of this.registeredClients) {
      if (registration.selector(options, body)) {
        const client = registration.client
        client.setBaseUrl(options.baseURL || this.linkCreator.getBase())
        return client
      }
    }

    const httpClient = this.httpClient
    httpClient.setBaseUrl(options.baseURL || this.linkCreator.getBase())
    return httpClient
  }

  getRegisteredClients(): ReadonlyArray<ClientRegistration> {
    return [...this.registeredClients]
  }
}
